namespace Nobox.Chat {
    export interface reportModel {
        CountConver?: number;
        CountUnassigned?: number;
        CountAssigned?: number;
        CountResolved?: number;
        CountCampaign?: number;
        CountArchived?: number;
        CountAgent?: number;
        CountSupervisor?: number;
        CountAgentSupervisor?: number;
        CountOnline?: number;
        CountOffline?: number;
        ArrTags?: TagsArr[];
        ArrFunnels?: FunnelArr[];
        ArrLblTags?: string[];
        ArrBgTags?: string[];
        ArrDataTags?: string[];
        ArrLblFunn?: string[];
        ArrBgFunn?: string[];
        ArrDataFunn?: string[];
        ArrPerHour?: perHour[];
        ArrPerDay?: perDay[];
    }
}
